import i18n from '@/i18n';

const t = (key) => i18n.global.t(key);

export default class WeekDay {
    id;

    constructor(id) {
        this.id = id;
    }

    static constructFromObject(data) {
        return new WeekDay(typeof data === 'object' ? data.id : data);
    }

    toString() {
        const key = `weekDay.${this.id}`;
        return t(key) !== key ? t(key) : t('weekDay.unknown');
    }
}
